__turbopack_context__.v({
  "about": "unit-page-module__QaZK0q__about",
  "address": "unit-page-module__QaZK0q__address",
  "amenities": "unit-page-module__QaZK0q__amenities",
  "ask": "unit-page-module__QaZK0q__ask",
  "askPill": "unit-page-module__QaZK0q__askPill",
  "closed": "unit-page-module__QaZK0q__closed",
  "columns": "unit-page-module__QaZK0q__columns",
  "count": "unit-page-module__QaZK0q__count",
  "dateWell": "unit-page-module__QaZK0q__dateWell",
  "decide": "unit-page-module__QaZK0q__decide",
  "decideApply": "unit-page-module__QaZK0q__decideApply",
  "decideLabel": "unit-page-module__QaZK0q__decideLabel",
  "decideRent": "unit-page-module__QaZK0q__decideRent",
  "description": "unit-page-module__QaZK0q__description",
  "desktopBar": "unit-page-module__QaZK0q__desktopBar",
  "fine": "unit-page-module__QaZK0q__fine",
  "fitLine": "unit-page-module__QaZK0q__fitLine",
  "fitMark": "unit-page-module__QaZK0q__fitMark",
  "gallery": "unit-page-module__QaZK0q__gallery",
  "galleryBar": "unit-page-module__QaZK0q__galleryBar",
  "galleryButton": "unit-page-module__QaZK0q__galleryButton",
  "galleryNext": "unit-page-module__QaZK0q__galleryNext",
  "galleryPhoto": "unit-page-module__QaZK0q__galleryPhoto",
  "galleryPrev": "unit-page-module__QaZK0q__galleryPrev",
  "galleryTrack": "unit-page-module__QaZK0q__galleryTrack",
  "glass": "unit-page-module__QaZK0q__glass",
  "glassRow": "unit-page-module__QaZK0q__glassRow",
  "hero": "unit-page-module__QaZK0q__hero",
  "heroPhoto": "unit-page-module__QaZK0q__heroPhoto",
  "heroText": "unit-page-module__QaZK0q__heroText",
  "loading": "unit-page-module__QaZK0q__loading",
  "missing": "unit-page-module__QaZK0q__missing",
  "num": "unit-page-module__QaZK0q__num",
  "page": "unit-page-module__QaZK0q__page",
  "pageInner": "unit-page-module__QaZK0q__pageInner",
  "phoneApply": "unit-page-module__QaZK0q__phoneApply",
  "phoneBack": "unit-page-module__QaZK0q__phoneBack",
  "phoneBar": "unit-page-module__QaZK0q__phoneBar",
  "phoneBarText": "unit-page-module__QaZK0q__phoneBarText",
  "phoneCount": "unit-page-module__QaZK0q__phoneCount",
  "strip": "unit-page-module__QaZK0q__strip",
  "stripMore": "unit-page-module__QaZK0q__stripMore",
  "stripPhoto": "unit-page-module__QaZK0q__stripPhoto",
  "subhead": "unit-page-module__QaZK0q__subhead",
  "tile": "unit-page-module__QaZK0q__tile",
  "viewport": "unit-page-module__QaZK0q__viewport",
  "where": "unit-page-module__QaZK0q__where",
});
